//projectlab-web/src/components/ui/Textarea.tsx
import { forwardRef, TextareaHTMLAttributes } from 'react';
import { clsx } from 'clsx';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?:    string;
  error?:    string;
  hint?:     string;
  maxCount?: number;
  required?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, hint, maxCount, required, className, id, value, ...props }, ref) => {
    const textareaId = id ?? label?.toLowerCase().replace(/\s+/g, '-');
    const charCount  = typeof value === 'string' ? value.length : 0;
    return (
      <div className="flex flex-col gap-1.5 w-full">
        {label && (
          <label htmlFor={textareaId} className="text-xs font-semibold uppercase tracking-wide text-[var(--color-text-muted)]">
            {label}{required && <span className="text-[var(--color-error)] ml-0.5">*</span>}
          </label>
        )}
        <textarea
          ref={ref}
          id={textareaId}
          value={value}
          aria-invalid={!!error}
          className={clsx(
            'input-base resize-none min-h-[100px] leading-relaxed',
            error && 'error',
            className,
          )}
          {...props}
        />
        <div className="flex items-center justify-between">
          {error
            ? <p role="alert" className="text-xs text-[var(--color-error)]">{error}</p>
            : hint
              ? <p className="text-xs text-[var(--color-text-muted)]">{hint}</p>
              : <span />
          }
          {maxCount !== undefined && (
            <p className={clsx(
              'text-xs font-tabular',
              charCount > maxCount ? 'text-[var(--color-error)]' : 'text-[var(--color-text-faint)]',
            )}>
              {charCount}/{maxCount}
            </p>
          )}
        </div>
      </div>
    );
  }
);
Textarea.displayName = 'Textarea';
